import { useEffect } from "react";

interface MetaOptions {
  title?: string;
  description?: string;
  keywords?: string;
}

function setMetaTag(name: string, content?: string) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setOgTag(property: string, content?: string) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setOgTag("og:title", title);
      setOgTag("twitter:title", title);
    }
    if (description) {
      setMetaTag("description", description);
      setOgTag("og:description", description);
      setOgTag("twitter:description", description);
    }
    if (keywords) {
      setMetaTag("keywords", keywords);
    }
  }, [title, description, keywords]);
}